export default "__VITE_ASSET__B2iMu9po__"